/* Ballon King: carries the homepage wish date into the Buunto date picker on product pages.
   Source: ?wunschdatum=YYYY-MM-DD or localStorage 'bk:wunsch' (set by bk-v3.js).
   Buunto's selectDate() does not validate, so the date is checked here against the live
   Buunto settings first. Never overrides a date the cart already has (one date per order). */
(function () {
  'use strict';
  if (window.__bkPdp) return;
  window.__bkPdp = true;

  var DAY = 864e5;
  var WDN = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];

  function wish() {
    var m = location.search.match(/[?&]wunschdatum=(\d{4}-\d\d-\d\d)/);
    if (m) return { d: m[1], m: 'delivery' };
    try {
      var o = JSON.parse(localStorage.getItem('bk:wunsch') || 'null');
      if (o && /^\d{4}-\d\d-\d\d$/.test(o.d)) return { d: o.d, m: o.m === 'pickup' ? 'pickup' : 'delivery' };
    } catch (_) {}
    return null;
  }
  // Zurich wall clock as fake-UTC ms (same convention as bk-v3.js)
  function zNow() {
    try {
      var p = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Zurich', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = +x.value; });
      return Date.UTC(p.year, p.month - 1, p.day, p.hour % 24, p.minute);
    } catch (_) { return 0; }
  }
  function bookable(w, s) {
    var ms = Date.parse(w.d + 'T00:00:00Z'), day = new Date(ms).getUTCDay(), pick = w.m === 'pickup';
    var days = (s.availableDaysByMethod || {})[pick ? 'STORE_PICKUP' : 'LOCAL_DELIVERY'] || WDN.slice(1);
    var off = (pick ? s.pickupDisabledDates : s.disabledDates) || [];
    if (days.indexOf(WDN[day]) < 0 || off.indexOf(w.d) >= 0) return false;
    var tbl = (pick ? s.pickupCutOffByDay : s.cutOffByDay) || {}, c = tbl[WDN[day]] || tbl.DEFAULT;
    if (!c) return false;
    var t = String(c.cutOffTime || '16:00').split(':');
    var cut = ms - (+c.firstAvailableDateInDays || 0) * DAY + (+t[0] || 0) * 36e5 + (+t[1] || 0) * 6e4;
    var now = zNow();
    return !!now && cut > now;
  }
  function whenReady(done) {
    var n = 0;
    (function poll() {
      var api = window.Buunto && window.Buunto.datePicker;
      if (api && api.selectDate && document.querySelector('.buunto-date-picker')) { done(api); return; }
      if (++n < 80) setTimeout(poll, 250);
    })();
  }

  var w = wish();
  if (!w) return;
  var shop = (window.Shopify && window.Shopify.shop) || 'ballonking.myshopify.com';
  Promise.all([
    fetch('https://cdn.buunto.com/datepicker_settings/' + shop + '.json').then(function (r) { return r.json(); }),
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
  ]).then(function (res) {
    var s = res[0] && (res[0].widgetSettings || res[0]), cart = res[1] || {};
    var dated = (cart.items || []).some(function (it) { var p = it.properties || {}; return p.Lieferdatum || p.Abholdatum; });
    if (!s || dated || !bookable(w, s)) return;
    whenReady(function (api) {
      var go = function () { try { api.selectDate(w.d); } catch (_) {} };
      if (w.m !== 'pickup') { go(); return; }
      var btn = [].slice.call(document.querySelectorAll('.buunto-method-field, .buunto-method-field *'))
        .filter(function (el) { return /Abholung/.test(el.textContent || '') && (el.tagName === 'BUTTON' || el.tagName === 'LABEL' || el.getAttribute('role') === 'button' || el.tagName === 'INPUT'); })[0];
      if (btn) { btn.click(); setTimeout(go, 400); } else go();
    });
  }).catch(function () {});
})();
